import React, { useEffect, useState } from 'react';
import './Menu.scss'
import SideMenuItem from '../sideMenuItem/SideMenuItem';
import Grid from '@mui/material/Grid';
import { Divider, Stack } from '@mui/material';
import { GetMenuAsync } from '../../httpService';
import * as XLSX from 'xlsx';
import { getAllergensList, getBeers, getDate, getDegu, getDetails, getMenu, getWines } from './MenuHelper';
import { IMenu } from '../../models/IMenu';
import TopMenuItem from '../topMenuItem/TopMenuItem';
import LaCarteMenu from '../laCarteMenu/LaCarteMenu';
import WineList from '../wineList/WineList';
import BeerList from '../beerList/BeerList';
import DrinkList from '../drinkList/DrinkList';
import AllergensModal from './AllergensModal';
import TastingMenu from '../tastingMenu/TastingMenu';

export enum Selections {
    laCarte,
    tasting,
    wine,
    beer,
    beverage
}

function MenuPage(props: any) {
    const [date, setDate] = useState<string>("");
    const [menu, setMenu] = useState<IMenu>();
    const [active, setActive] = useState<Selections>(Selections.laCarte);
    const [allergensList, setAllergensList] = useState<[number, string][]>([]);
    const [allergensModalOpen, setAllergensModalOpen] = useState<boolean>(false);
    const cartaIcon = 'menu.png';
    const degustazioneIcon = 'tasting.png';
    const wineIcon = 'wine.png';
    const beerIcon = 'beer.png';
    const beverageIcon = 'drink.png';


    useEffect(() => {
        getFile();
    }, [])


    const getFile = async () => {
        var menu = await GetMenuAsync();
        parseExcel(menu);
    }

    const parseExcel = async (file: Blob) => {
        var ab = await file.arrayBuffer();
        const workbook = XLSX.read(ab);


        var dt = getDate(workbook.Sheets["Data"]);
        var menuCarta = getMenu(workbook.Sheets["Carta"]);
        var menuDegustazione = getDegu(workbook.Sheets["Degustazione"]);
        var beers = getBeers(workbook.Sheets["Birre"]);
        var wines = getWines(workbook.Sheets["Vini"]);
        var details = getDetails(workbook.Sheets["Varie"]);
        var al = getAllergensList(workbook.Sheets["Allergeni"]);
        setAllergensList(al);
        setDate(dt);
        setMenu({
            laCarte: {
                appetizers: menuCarta[0],
                first: menuCarta[1],
                second: menuCarta[2],
                side: menuCarta[3],
                sweet: menuCarta[4]
            },
            tasting: menuDegustazione,
            wines: wines,
            beers: beers,
            various: details
        });


    }

    const openAllergensModal = () => {
        setAllergensModalOpen(true);
    }

    const closeAllergensModal = () => {
        setAllergensModalOpen(false);
    }

    return (
        <Grid container className='menu-container'>

            <Grid item xs={0} md={12} lg={7} >
                <Stack className=''>
                    <div className='top-menu-container'>
                        <TopMenuItem onClick={() => setActive(Selections.laCarte)} iconName={cartaIcon} />
                        <TopMenuItem onClick={() => setActive(Selections.tasting)} iconName={degustazioneIcon} />
                        <TopMenuItem onClick={() => setActive(Selections.wine)} iconName={wineIcon} />
                        <TopMenuItem onClick={() => setActive(Selections.beer)} iconName={beerIcon} />
                        <TopMenuItem onClick={() => setActive(Selections.beverage)} iconName={beverageIcon} />
                    </div>
                    {
                        active == Selections.laCarte ? <LaCarteMenu onAllergensListClick={openAllergensModal} menu={menu?.laCarte} various={menu?.various} /> :
                            active == Selections.tasting ? <TastingMenu  openAllergensListModal={openAllergensModal} menu={menu?.tasting} price={menu?.various.prezzoDegu} /> :
                                active == Selections.wine ? <WineList wines={menu?.wines} /> :
                                    active == Selections.beer ? <BeerList beers={menu?.beers} /> :
                                        active == Selections.beverage ? <DrinkList various={menu?.various} /> : <></>
                    }
                </Stack>
            </Grid>

            <Grid item xs={0} md={0} lg={5} className='side-menu '>
                <div className='p-2 side-menu-content'>
                    <AllergensModal allergensList={allergensList} onClose={closeAllergensModal} open={allergensModalOpen} />
                    <div className='side-menu-container'>

                        <SideMenuItem onClick={() => setActive(Selections.laCarte)} iconName={cartaIcon} label='Menù alla carta' />
                        <Divider variant="middle" />
                        <SideMenuItem onClick={() => setActive(Selections.tasting)} iconName={degustazioneIcon} label='Menù degustazione' />
                        <Divider variant="middle" />
                        <SideMenuItem onClick={() => setActive(Selections.wine)} iconName={wineIcon} label='Carta dei vini' />
                        <Divider variant="middle" />
                        <SideMenuItem onClick={() => setActive(Selections.beer)} iconName={beerIcon} label='Carta delle birre' />
                        <Divider variant="middle" />
                        <SideMenuItem onClick={() => setActive(Selections.beverage)} iconName={beverageIcon} label='Bevande' />
                    </div>
                </div>
            </Grid>
        </Grid>
    );
}


export default MenuPage;


